const elSlideshowFs = document.getElementById('slideshow-fs');
const elSsImage = document.getElementById('ss-image');
const elSsVideo = document.getElementById('ss-video');
const elSsProgressBar = document.getElementById('ss-progress-bar');
const elBtnStart = document.getElementById('start-slideshow');
const elBtnPause = document.getElementById('ss-pause');
const elBtnExit = document.getElementById('ss-exit');
const elControls = document.getElementById('ss-controls');

let slideshowList = [];
let currentIndex = -1;
let isPlaying = false;
let photoDuration = 5; // seconds
let timer = null;
let controlsTimeout = null;
let lastFetchTime = null;

export function initSlideshow() {
  elBtnStart.addEventListener('click', startSlideshow);
  elBtnPause.addEventListener('click', togglePause);
  elBtnExit.addEventListener('click', exitSlideshow);
  
  // Hide controls when not moving mouse
  elSlideshowFs.addEventListener('mousemove', showControlsBriefly);
  
  document.addEventListener('fullscreenchange', () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      exitSlideshow();
    }
  });
}

async function fetchSlideshowMedia() {
  try {
    const order = document.getElementById('slideshow-order').value;
    const durationSelect = document.getElementById('slideshow-duration').value;
    const mediaType = document.getElementById('slideshow-media-type').value;
    photoDuration = parseInt(durationSelect, 10);
    
    // Fetch all or up to a reasonable limit for the slideshow (e.g., 200 items)
    const token = window.getAuthToken();
    if (!token) return [];
    
    let url = `/api/media?page=1&limit=100`;
    if (mediaType !== 'all') url += `&type=${mediaType}`;

    const res = await fetch(url, { 
      headers: { 'Authorization': `Bearer ${token}` } 
    });
    const data = await res.json();
    let media = data.media;
    
    if (order === 'oldest') {
      media.reverse();
    } else if (order === 'random') {
      for (let i = media.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [media[i], media[j]] = [media[j], media[i]];
      }
    }
    
    lastFetchTime = new Date().toISOString();
    return media;
  } catch(e) {
    console.error("Slideshow fetch error", e);
    return [];
  }
}

async function pullNewUploads() {
    if (!isPlaying || !lastFetchTime) return;
    try {
        const token = window.getAuthToken();
        const mediaType = document.getElementById('slideshow-media-type').value;
        
        let url = `/api/media?page=1&limit=50&since=${encodeURIComponent(lastFetchTime)}`;
        if (mediaType !== 'all') url += `&type=${mediaType}`;

        const res = await fetch(url, { 
          headers: { 'Authorization': `Bearer ${token}` } 
        });
        const data = await res.json();
        
        if (data.media && data.media.length > 0) {
            console.log("Found new uploads:", data.media.length);
            // Insert after current index so they play soon
            const order = document.getElementById('slideshow-order').value;
            let newItems = data.media;
            if (order === 'random') {
                for (let i = newItems.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [newItems[i], newItems[j]] = [newItems[j], newItems[i]];
                }
            }
            
            // Insert right after current
            slideshowList.splice(currentIndex + 1, 0, ...newItems);
            lastFetchTime = new Date().toISOString();
        }
    } catch(e) {
        // ignore
    }
}

async function startSlideshow() {
  const originalBtnText = elBtnStart.innerHTML;
  elBtnStart.innerHTML = '<div class="spinner" style="width:20px;height:20px;border-width:2px;margin:auto"></div>';
  elBtnStart.disabled = true;

  slideshowList = await fetchSlideshowMedia();
  
  elBtnStart.innerHTML = originalBtnText;
  elBtnStart.disabled = false;

  if (slideshowList.length === 0) {
    alert("Noch keine Fotos hochgeladen.");
    return;
  }

  currentIndex = -1;
  isPlaying = true;
  elSlideshowFs.classList.remove('hidden');
  
  if (elSlideshowFs.requestFullscreen) {
    elSlideshowFs.requestFullscreen();
  } else if (elSlideshowFs.webkitRequestFullscreen) { /* Safari */
    elSlideshowFs.webkitRequestFullscreen();
  }

  showControlsBriefly();
  nextSlide();
  
  // Try to pull new uploads every 10 minutes
  setInterval(pullNewUploads, 600000);
}

function stopSlideTimer() {
  if (timer) clearInterval(timer);
  elSsProgressBar.style.transition = 'none';
  elSsProgressBar.style.width = '0%';
}

function togglePause() {
  isPlaying = !isPlaying;
  elBtnPause.textContent = isPlaying ? '⏸' : '▶';
  
  if (isPlaying) {
    // Resume
    const cur = slideshowList[currentIndex];
    if (cur.media_type === 'video') {
      elSsVideo.play();
    } else {
      startSlideTimer(photoDuration * 1000); // restart full timer for simplicity
    }
  } else {
    // Pause
    stopSlideTimer();
    if (slideshowList[currentIndex]?.media_type === 'video') {
      elSsVideo.pause();
    }
  }
}

function exitSlideshow() {
  isPlaying = false;
  stopSlideTimer();
  elSsVideo.pause();
  elSsVideo.src = '';
  elSsImage.src = '';
  elSsImage.classList.remove('active');
  elSsVideo.classList.remove('active');
  elSlideshowFs.classList.add('hidden');
  
  if (document.fullscreenElement || document.webkitFullscreenElement) {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  }
}

async function nextSlide() {
  if (!isPlaying) return;
  stopSlideTimer();
  
  currentIndex++;
  if (currentIndex >= slideshowList.length) {
    const shouldLoop = document.getElementById('slideshow-loop').checked;
    if (shouldLoop) {
      currentIndex = 0;
    } else {
      exitSlideshow();
      return;
    }
  }

  const item = slideshowList[currentIndex];
  
  // Fade out old
  elSsImage.classList.remove('active');
  elSsVideo.classList.remove('active');
  
  await new Promise(r => setTimeout(r, 600)); // wait for crossfade out

  if (item.media_type === 'image') {
    elSsVideo.pause();
    const url = window.getMediaUrl(item.url);
    elSsImage.src = url;
    
    elSsImage.onload = () => {
      elSsImage.classList.add('active');
      startSlideTimer(photoDuration * 1000);
    };
  } else {
    // Video
    elSsVideo.src = window.getMediaUrl(item.url);
    elSsVideo.classList.add('active');
    
    // Explicit load is sometimes needed on mobile
    elSsVideo.load();

    const playPromise = elSsVideo.play();
    if (playPromise !== undefined) {
      playPromise.catch(e => {
        console.warn('Video autoplay failed', e);
        // Fallback if video can't play automatically
        startSlideTimer(photoDuration * 1000);
      });
    }

    elSsVideo.onended = () => {
      if(isPlaying) nextSlide();
    };
    
    // In case video gets stuck or is too short, safety timer
    startSlideTimer(Math.max((item.duration || 15) * 1000, 3000), true);
  }
}

function startSlideTimer(ms, isVideo = false) {
  stopSlideTimer();
  
  if (!isVideo) {
    requestAnimationFrame(() => {
      elSsProgressBar.style.transition = `width ${ms}ms linear`;
      elSsProgressBar.style.width = '100%';
    });
  } else {
    // For video, progress bar is handled differently or hidden, but we still need the fallback timer
    elSsProgressBar.style.transition = 'none';
    elSsProgressBar.style.width = '0%';
  }
  
  timer = setTimeout(() => {
    if (isPlaying) nextSlide();
  }, ms);
}

function showControlsBriefly() {
  elControls.style.opacity = '1';
  document.body.style.cursor = 'default';
  
  if (controlsTimeout) clearTimeout(controlsTimeout);
  
  controlsTimeout = setTimeout(() => {
    if (isPlaying) {
      elControls.style.opacity = '0';
      document.body.style.cursor = 'none';
    }
  }, 3000);
}
